export function isMobile() {
  return window.matchMedia("screen and (max-width: 768px)").matches;
}
